import React from 'react';
import { connect } from "react-redux";
import { getRecibos } from '../../recibos/RecibosService';
import { Link } from "react-router-dom";
import pdfIcon from "../../../assets/images/icons/pdf_24.svg";

class TablaLoteDetalle extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          page: 0,
          pageSize: 10,
          totalCount: 0,
          totalPages: 0,
          search: "",
          loading: false,
          recibos: [],
        };
      }
    
      componentDidMount() {
        this.fetchRecibos();
      }
    
      fetchRecibos = () => {
        const { page, pageSize, search } = this.state;
        const { idLote } = this.props;
    
        this.setState({ loading: true });
    
        this.props.getRecibos(page, pageSize, search, idLote)
          .then(() => {
            this.setState({
                recibos: this.props.recibosData.recibos,
                page: this.props.recibosData.page,
                totalCount: this.props.recibosData.totalCount,
                totalPages: Math.ceil(this.props.recibosData.totalCount / pageSize),
                loading: false 
              });
          })
          .catch((error) => {
            console.error("Error al cargar recibos:", error);
            this.setState({ loading: false });
          });
      };
    
      handleSearchChange = (event) => {
        this.setState(
          { search: event.target.value, page: 0 }, 
          () => this.fetchRecibos()
        );
      };
    
      handlePageChange = (direction) => {
        this.setState(
          (prevState) => ({
            page: direction === "next" ? prevState.page + 1 : prevState.page - 1,
          }),
          () => this.fetchRecibos()
        );
      };
    
      render() {
        const { recibos, loading, page, pageSize, totalCount, totalPages, search } = this.state;
    
        return (
          <div className="component-table">
            <div className="component-pagination">
              <h5 className="list-title">Procede a firmar el documento seleccionado</h5>
    
              <div className="pagination-actions">
                <form className="search-form form" onSubmit={(e) => e.preventDefault()}>
                  <div className="search-group">
                    <div className="input-icon">
                      <span className="material-symbols-outlined">search</span>
                    </div>
                    <input
                      type="search"
                      className="input-search"
                      placeholder="Buscar..."
                      value={search}
                      onChange={this.handleSearchChange}
                    />
                  </div>
                </form>
    
                <div className="pagination">
                  <span className="info-pages">
                    {totalCount === 0 ? "0" : (page * pageSize + 1)}-{Math.min((page + 1) * pageSize, totalCount)} de {totalCount}
                  </span>
                  <button
                    className={`btn-prev ${page === 0 ? "btn-disabled" : ""}`}
                    onClick={() => this.handlePageChange('prev')}
                    disabled={page === 0}
                  >
                    <span className="material-symbols-outlined">navigate_before</span>
                  </button>
                  <button
                    className={`btn-next ${page >= totalPages - 1 ? "btn-disabled" : ""}`}
                    onClick={() => this.handlePageChange('next')}
                    disabled={page >= totalPages - 1}
                  >
                    <span className="material-symbols-outlined">navigate_next</span>
                  </button>
                </div>
              </div>
            </div>
    
            <div className="responsive-table">
              <table>
                <thead>
                  <tr>
                    <th>Documento</th>
                    <th>Fecha de carga</th>
                    <th>Colaborador</th>
                    <th>Estado</th>
                    <th>Estado MTESS</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="6">Cargando...</td>
                    </tr>
                  ) : recibos.length === 0 ? (
                    <tr>
                      <td colSpan="6">No se encontraron resultados</td>
                    </tr>
                  ) : (
                    recibos.map((recibo, index) => (
                      <tr key={index}>
                        <td>{recibo.recibo}</td>
                        <td>{recibo.fechaCarga}</td>
                        <td>{recibo.empleado}</td>
                        <td>
                            <span className="label__info">
                                {recibo.estado}
                            </span>
                        </td>
                        <td>{recibo.estadoMTESS ? "Sí" : "No"}</td>
                        <td>
                          <div className="table-actions">
                            <Link to={{
                              pathname: `/recibo/${recibo.recibo}/lote/${recibo.idLote}/ver`,
                              state: {descripcionLote: recibo.descripcionLote}
                            }}>
                              <button className="table-icon">
                                <img src={pdfIcon} alt="ver_pdf" />
                              </button>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        );
      }
}

const mapDispatchToProps = (dispatch) => ({
    getRecibos: (page, size, search, idLote) => dispatch(getRecibos(page, size, search, idLote)),
  });
  
  const mapStateToProps = (state) => ({
    recibosData: state.recibosData,
  });
  
  export default connect(mapStateToProps, mapDispatchToProps)(TablaLoteDetalle);